<template>
  <v-app id="inspire">
    <!-- Navigation Drawer with Toggle Button -->
    <v-navigation-drawer
      disable-resize-watcher
      dark
      color="secondary"
      v-model="drawer"
      app
      clipped
      permanent
      mobile-breakpoint="400"
      :width="drawer ? 400 : (showFilters ? 60 : 0)"
      height="100%"
    >
      <!-- Toggle Button Inside Drawer -->
      <v-btn
        icon
        @click="drawer = !drawer"
        class="toggle-btn"
      >
        <v-icon>{{ drawer ? '' : 'mdi-magnify' }}</v-icon>
      </v-btn>

      <tender-filters v-show="drawer" v-on:showNav="toggleDrawer" />
    </v-navigation-drawer>

    <v-app-bar
      v-if="app_bar_active"
      app
      clipped-left
      clipped-right
      fixed
      
      dark
      color="secondary"
      height="56"
      flat
      style="border-bottom : 2px solid rgb(255, 20, 99) !important;"
    >
      <div class="logo">
        <router-link to="/" style="color: white; text-decoration: none">
          <v-img
            src="@/assets/img/logo-white.png"
            max-height="22"
            max-width="22"
            contain
            class="desktop px-0 mx-0"
          ></v-img>
          <v-img
            src="@/assets/img/tendle_logo-thumbnail-white.svg"
            max-height="20"
            max-width="20"
            contain
            style="margin-right: 10px ; margin-left:0px"
            class="mobile"
          ></v-img>
        </router-link>
      </div>
 
        <span v-if="app_bar_active && $route.name != 'home'">
          <user-history />
        </span>

        <div class="flex-grow-1"></div>
        <span>
          <v-tooltip bottom dark color="#000000" style="opacity: 0.7;">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  :disabled="disabled()"
                >
                <router-link to="/">
                  <v-icon color="#FFFFFF">mdi-home</v-icon>
                </router-link>
                </v-btn>
              </template>
              <span>Home</span>
            </v-tooltip>
        </span>
        <span>
          <v-badge
            :color="badge_color"
            :value="badge_visible"
            :content="num_matches"
            offset-x="15"
            
            left
            overlap
          >
            <v-btn
              v-if="app_bar_active"
              class="text-capitalize body-2 desktop-nav "
              small
              dark
              text
              depressed
              tile
              @click="$router.push({ name: 'inbox' })"
              >Alerts
            </v-btn>
  
          </v-badge>

        </span>
        <span>
          <v-menu
            v-if="app_bar_active"
            v-model="showEntityMenu"
            offset-y
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-capitalize body-2 desktop-nav"
                small
                dark
                text
                depressed
                tile
                v-bind="attrs"
                v-on="on"
              >
                Directories
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card dark color="secondary" class="body-2" min-width="100" max-width="200">
              <v-list dense color="secondary">

                  <v-list-item style="text-decoration:none !important; color:white !important;"
                    v-for="(item, i) in directory_items"
                    :key="i"
                    @click.native="showEntityMenu = false"
                    :to="{ name: item.route }"
                  >
                    <!-- <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon> -->
                    <v-list-item-content>
                      <v-list-item-title>{{item.text}}
                        
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

              </v-list>
              
            </v-card>
          </v-menu>
        </span>

        <span>
          <v-menu
            v-if="app_bar_active"
            v-model="showMyLibraries"
            offset-y
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-capitalize body-2 desktop-nav"
                small
                dark
                text
                depressed
                tile
                v-bind="attrs"
                v-on="on"
              >
                My Items
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card dark color="secondary" class="body-2 font-weight-medium" min-width="200" max-width="300">
              <v-list dense color="secondary">
                <v-list-item style="text-decoration:none !important; color:white !important;" @click="showMyLibraries = false">
                  <router-link to="/reports" style="color: white!important; text-decoration: none;">
                    Reports
                  </router-link>
       
                </v-list-item>

                <v-list-item style="text-decoration:none !important; color:white !important;" @click="showMyLibraries = false">
                  <router-link to="/clusters?entity_type=supplier" style="color: white!important; text-decoration: none;">
                    Supplier Clusters
                  </router-link>
                </v-list-item>

                <v-list-item style="text-decoration:none !important; color:white !important;" @click="showMyLibraries = false">
                  <router-link to="/clusters?entity_type=publisher" style="color: white!important; text-decoration: none;">
                    Buyer Clusters
                  </router-link>
                </v-list-item>
                <v-list-item style="text-decoration:none !important; color:white !important;" @click="showMyLibraries = false">
                  <router-link to="/pipelines" style="color: white!important; text-decoration: none;">
                    Pipelines <span class="font-weight-light">(Prospect Lists)</span>
                  </router-link>
                </v-list-item>
                <v-list-item style="text-decoration:none !important; color:white !important;" @click="showMyLibraries = false">
                  <router-link to="/search-profiles" style="color: white!important; text-decoration: none;">
                    Search Profiles
                  </router-link>
                </v-list-item>
              </v-list>
              
            </v-card>
          </v-menu>
        </span>
        <!-- <span>
          <v-menu
              v-if="app_bar_active"
              v-model="showIndustryMenu"
              offset-y
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize body-2 desktop-nav"
                  small
                  dark
                  text
                  depressed
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  Industry
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-card dark color="secondary" class="body-2 font-weight-medium" min-width="100" max-width="200">
                <v-list dense color="secondary">
                  <v-list-item style="text-decoration:none !important; color:white !important;" @click="showIndustryMenu = false">
                    <router-link to="/audits" style="color: white!important; text-decoration: none;">
                      Audit Reports
                    </router-link>
                  </v-list-item>

                </v-list>
                
              </v-card>
            </v-menu>
        </span> -->
        
        <div class="desktop-nav">
          <v-tabs
            color="#4EB888"
            v-model="drawer_tabs"
            background-color="secondary"
            show-arrows
            hide-slider
          >
            <!-- <v-tooltip bottom dark color="#000000" style="opacity: 0.7;">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="showHide(0)"
                  class="v-app-bar-icon"
                >
                  <v-icon>mdi-bookmark-outline</v-icon>
                </v-tab>
              </template>
              <span>Prospect Lists</span>
            </v-tooltip> -->

            <v-tooltip bottom dark color="#000000" style="opacity: 0.7;">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="isDrawerFullScreen = false, showHide(0)"
                >
                  <span
                    class="text-capitalize body-2 desktop-nav "
                    >Search Profiles
                  </span>
                  <!-- <v-icon>mdi-view-headline</v-icon> -->
                </v-tab>
              </template>
              <span>View My Search Profiles</span>
            </v-tooltip> 
            <v-tooltip bottom dark color="#000000" style="opacity: 0.7;">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="showHide(1)"
                  class="v-app-bar-icon"
                >
                  <v-icon color="#FFE70A">mdi-creation</v-icon>
                </v-tab>
              </template>
              <span>AI-assisted Contracts Search</span>
            </v-tooltip> 
            <v-tooltip bottom dark color="#000000" style="opacity: 0.7;">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="isDrawerFullScreen = false, showHide(2)"
                  class="v-app-bar-icon"
                >
                  <v-avatar size="30px" v-if="$auth.user.picture">
                    <img small :src="$auth.user.picture"
                        alt="User's profile picture"/>
                  </v-avatar>
                  <v-avatar size="30px" v-else color="primary">
                    <v-icon dark>
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                </v-tab>
              </template>
              <span>My Profile</span>
            </v-tooltip> 

            <v-tooltip bottom dark color="#000000" style="opacity: 0.7;">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="isDrawerFullScreen = false, showHide(3)"
                  class="v-app-bar-icon"
                >
                  <v-icon color="rgb(255, 20, 99)">mdi-help-circle</v-icon>
                </v-tab>
              </template>
              <span>Help</span>
            </v-tooltip>
          </v-tabs>
        </div>
  
    </v-app-bar>

    <div class="mobile-nav">
      <v-bottom-navigation fixed horizontal :input-value="app_bar_active">
        <v-tabs
          color="#4EB888"
          v-model="drawer_tabs"
          background-color="FFFFFF"
          show-arrows
          hide-slider
        >
        <v-tooltip bottom dark color="#000000">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="showHide(0)"
                  class="v-app-bar-icon"
                >
                  <v-icon>mdi-view-headline</v-icon>
                </v-tab>
              </template>
              <span style="color: white!important; text-decoration: none;">Search Profiles</span>
            </v-tooltip> 
            <v-tooltip bottom dark color="#000000">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="showHide(1)"
                  class="v-app-bar-icon"
                >
                  <v-icon>mdi-creation</v-icon>
                </v-tab>
              </template>
              <span>AI-supported Search</span>
            </v-tooltip> 
            <v-tooltip bottom dark color="#000000">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="showHide(2)"
                  class="v-app-bar-icon"
                >
                  <v-avatar size="30px" v-if="$auth.user.picture">
                    <img small :src="$auth.user.picture"
                        alt="User's profile picture"/>
                  </v-avatar>
                  <v-avatar size="30px" v-else color="primary">
                    <v-icon dark>
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                </v-tab>
              </template>
              <span>My Profile</span>
            </v-tooltip> 

            <v-tooltip bottom dark color="#000000">
              <template v-slot:activator="{ on }">
                <v-tab
                  v-on="on"
                  :disabled="disabled()"
                  @click="showHide(3)"
                  class="v-app-bar-icon"
                >
                  <v-icon color="rgb(255, 20, 99)">mdi-help-circle</v-icon>
                </v-tab>
              </template>
              <span>Help</span>
            </v-tooltip>
        </v-tabs>
      </v-bottom-navigation>
    </div>

    <v-navigation-drawer
      disable-resize-watcher
      v-model="right_drawer"
      right
      app
      temporary
      :width="isDrawerFullScreen ? 'calc(100vw - 40px)' : '50%'"
      :class="{ 'fullscreen-drawer': isDrawerFullScreen }"
      class="ma-3"
    >
      <v-card width="100%" height="100vh">
        <v-tabs-items v-model="drawer_tabs">
          <v-tab-item :disabled="disabled()">
            <favourites @closeDrawer="right_drawer = false" />
          </v-tab-item>
          <v-tab-item :disabled="disabled()">
            <v-card class="font-weight-bold subtitle-1 py-4 px-4">
              <v-card-title class="pa-0 ma-0">
                <span>
                  <v-badge
                    color="secondary"
                    offset-x="0"
                    right
                    small
                    overlap
                  >
                    <template v-slot:badge>  <span class="text--black">Beta</span>
                    </template>
                    <!-- <v-icon medium class="pr-2">mdi-creation</v-icon> -->
                    Tracey
                  </v-badge>
                </span>
                <div class="flex-grow-1"></div>
                <span>
                  <v-btn icon small @click="isDrawerFullScreen = !isDrawerFullScreen">
                    <v-icon>{{ isDrawerFullScreen ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
                  </v-btn>
                </span>
                <span>
                  <v-btn icon @click="right_drawer = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </span>
              </v-card-title>
              <span class="font-weight-normal caption">
                  Contract search assistant. Try the public beta for free.
              </span>
              <div>
                <span @click="sendProductFeedback('Tracey')" class="text-capitalize font-weight-bold caption" style="cursor: pointer;">
                  Share your feedback
                </span>
              </div>
            </v-card>
            
            <v-card flat tile>
              <v-divider></v-divider>
              <tracey-chat-window
                :isFullScreen="isDrawerFullScreen"
                @toggle-fullscreen="isDrawerFullScreen = !isDrawerFullScreen"
                :reset="resetTracey"
                :searchParamsQry="searchParamsQry"
                @update-user-query="handleUserQueryUpdate"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item :disabled="disabled()">
            <login :menu="login_menu" :authenticated="authenticated" @close="right_drawer=false" />
          </v-tab-item>
          <v-tab-item :disabled="disabled()">
            <v-card flat>
              <v-card-title color="#12253a" class="title font-weight-bold subtitle-1"
                ><span>Help</span><div class="flex-grow-1"></div>
                <span>
                  <v-btn icon @click="right_drawer = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </span></v-card-title
              >
              <v-divider></v-divider>
              
              <!-- <v-card-text class="font-weight-bold pt-0">
                <a
                  href="https://tendertrace.com/privacy-policy/"
                  target="_blank"
                  >Privacy Policy</a
                ></v-card-text
              > -->

              <div class="mt-2 ml-1">
                  <v-btn
                    href="https://docs.tendertrace.com/guide"
                    target="_blank"
                    text
                    small
                    class="text-capitalize body-2"
                    
                    >User Guide <v-icon medium right outline>mdi-file-document</v-icon></v-btn
                  >
            </div>

                <div class="mt-2 ml-1">
                    <v-btn
                      @click="sendSupportMsg()"
                      v-bind="attrs"
                      v-on="on"
                      text
                      small
                      class="text-capitalize body-2"
                      
                      >Contact Support <v-icon medium right outline>mdi-headset</v-icon></v-btn
                    >
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-navigation-drawer>

    <router-view
      :drawer="drawer"
      :right_drawer="right_drawer"
      :drawer_data="drawer_data"
      :login_menu="login_menu"
      :authenticated="authenticated"
      :drawer_tabs="drawer_tabs"
    />

    <v-dialog v-model="dialog" width="300">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ dialog_title }}
        </v-card-title>

        <v-card-text>
          {{ dialog_msg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Got It
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </v-app>
</template>

<script>
//import { METHODS } from "http";
import TenderFilters from "./components/TenderFilters.vue";
import Favourites from "./components/Favourites.vue";
import Login from "./components/Login.vue";
//import MyLists from "./components/MyLists.vue";
import UserHistory from "./components/UserHistory.vue";
//import ClusterMenu from "./components/ClusterMenu.vue";
//import ChatQueryWindow from "./components/ChatQueryWindow.vue";

import { bus } from "./main.js";
import { getInstance } from "./auth/index.js";
import axios from "axios";
import { userLog } from "./components/APIManager.js";
import TraceyChatWindow from "./components/TraceyChatWindow.vue";

export default {
  components: {
    Favourites,
    Login,
    //MyLists,
    UserHistory,
    TenderFilters,
    TraceyChatWindow
  },
  props: {
    source: String
  },
  data() {
    return {
      isDrawerFullScreen: false,
      directory_items: [
        { text: 'Buyers', icon: 'mdi-domain', route:'entities'},
        { text: 'Suppliers', icon: 'mdi-account-multiple', route:'suppliers' },
        { text: 'Categories', icon: 'mdi-folder', route:'categories' },
        { text: 'Panels', icon: 'mdi-apps', route:'panels' },
        { text: 'Audits', icon: 'mdi-apps', route:'audits' }
      ],
      showIndustryMenu: false,
      queryDialog: false,
      app_bar_active: false,
      tool_bar_active: true,
      current_tab: Number,
      drawer_tabs: null,
      drawer_data: String,
      right_drawer: false,
      showFilters: false,
      drawer: false,
      recent_history_menu: true,
      favourites_menu: true,
      my_lists_menu: true,
      login_menu: true,
      logged_in_state_colour: "",
      authenticated: true,
      disable_nav: false,
      dialog_msg: "",
      dialog: false,
      dialog_title: "",
      search_terms: "",
      nav_open: true,
      closeEntityMenu: false,
      showEntityMenu: false,
      showMyLibraries: false,
      overlay: true,
      category_list: [],
      num_matches: 0,
      previousRoute: null
      //show_login_menu: false
    };
  },
  watch: {

    $route(to, from) {
      // Capture the full path of the route the user is navigating to
      const fullPath = window.location.origin + to.fullPath;

      userLog(fullPath);
      this.handleDrawerOnRoute(to, from);
    },

    isDrawerFullScreen(val) {
      document.body.style.overflow = val ? 'hidden' : '';
    }
  },
  
  computed: {
    badge_color(){

      if (this.num_matches > 0){
        return "primary";
      }
      else{
        return "secondary";
      }

    },

    badge_visible(){

      if (this.num_matches > 0){
        return true;
      }
      else{
        return false;
      }

    },

    appTitle() {
      return this.$store.state.appTitle;
    },

    loginStateColour() {
      return this.logged_in_state_colour;
    },

    displayBar() {
      if (this.app_bar_active) {
        //////////console.log("LOGGED IN")
        return { display: "none" };
      } else {
        return { display: "block" };
      }
    }
  },

  created() {
    if (this.$route.path.includes("/widgets/")){
        this.app_bar_active = false;
      }
  },

  mounted() {
    
    const instance = getInstance();
    instance.$watch("loading", async loading => {
      if (!loading && instance.isAuthenticated) {
        const token = await instance.getTokenSilently();
        this.tool_bar_active = false;
        if (this.$route.path.includes("/widgets/")){
          this.app_bar_active = false;
        }
        else{ 
          this.app_bar_active = true;
        }
        this.logged_in_state_colour = "#4EB888";
        this.disable_nav = false;
        //this.drawer = true;
        this.authenticated = true;
        this.overlay = false;
        this.getSavedSearches(token);
      }
      else {
        this.tool_bar_active = true;
        this.app_bar_active = false;
        this.logged_in_state_colour = "#FFFFFF";
        this.disable_nav = true;
        this.authenticated = false;
        this.right_drawer = false;
      }

    });

    this.handleDrawerOnRoute(this.$route, null);

    if (this.$route.path.includes("/widgets/")){
        this.app_bar_active = false;
    }

    bus.$on("hide-side-navs", hide => {
      //////////console.log("HIDE SIDE NAVS");
      this.right_drawer = false;
      //this.drawer = false;
    });

    bus.$on("show_dialog", dialog => {
      //////////console.log(`CALLED DIALOG :)` + dialog.msg  + " STATE: " + dialog.state);
      this.dialog_msg = dialog.msg;
      this.dialog_title = dialog.title;
      this.dialog = dialog.state;
    });

    bus.$on("hideFilters", show => {
      //////////console.log(`CALLED DIALOG :)` + dialog.msg  + " STATE: " + dialog.state);
      this.drawer = show;
    });
  },

  methods: {

    async sendProductFeedback(productFeature){
      this.currentURL = window.location.href;
      window.location.href = 'mailto:' + 'support@tendertrace.com?subject=Tendertrace Product Feedback&body=Product Feature: '+productFeature+ '%0D' + '%0DPlease enter your message below this line.%0D';
    },

    async sendSupportMsg(){
      this.currentURL = window.location.href;

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: 'pk_vU6EIAOfRouzmn3x'
        },
        body: JSON.stringify({
          allowDuplicates: false,
          domain: 'go.tendertrace.com',
          originalURL: this.currentURL
        })
      };

      fetch('https://api.short.io/links/public', options)
        .then(response => response.json())
        .then(response => {
          window.location.href = 'mailto:' + 'support@tendertrace.com?subject=Tendertrace Support Query&body=Source page: '+response.shortURL+ '%0D' + '%0DPlease enter your message below this line.%0D';
          return response.shortURL})
        .catch(err);

      //this.supportBody = await this.shortURL(this.currentURL) + '%0D' + '%0DPlease enter your message below this line.%0D';
    },

    async getSavedSearches(accessToken) {
      //const instance = getInstance();
      //const accessToken = await instance.getTokenSilently();

      axios
        .get(process.env.VUE_APP_API_SEARCHES, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
        .then(response => {
          //////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.data));
          this.num_matches = response.data.total_new_matches;
          //return this.saved_searches;
        })
        .catch(error => {
          //////////console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loadingSearches = false));
    },

    showHide(tabID) {
      if (!this.right_drawer) {
        //this.drawer = false;
        this.right_drawer = true;
      } else if (this.current_tab === tabID) {
        this.right_drawer = false;
        //this.drawer = true;
      } else {
        //this.drawer = false;
        this.right_drawer = true;
      }
      this.current_tab = tabID;
    },

    globalSearch(search_terms) {
      var query = search_terms;
      bus.$emit("global-search", query);
    },

    plaintextSearch(search_terms) {
      var query = search_terms;
      bus.$emit("plaintext-search", query);
    },

    getStateColor() {
      if (this.drawer === null) {
        return "#4EB888";
      } else if (this.drawer === true) {
        return "#4EB888";
      } else {
        return "#FFFFFF";
      }
    },

    getRightDrawerStateColor() {
      if (this.right_drawer) {
        return "#4EB888";
      } else {
        return "#FFFFFF";
      }
    },

    refresh() {
      bus.$emit("refresh_lists");
    },

    getLoginStateColor() {
      if (this.$auth.isAuthenticated) {
        this.logged_in_state_colour = "#4EB888";
        return this.logged_in_state_colour;
      } else {
        this.logged_in_state_colour = "#FFFFFF";
        return this.logged_in_state_colour;
      }
    },

    disabled() {
      if (this.$auth.isAuthenticated) {
        this.disable_nav = false;
        return this.disable_nav;
      } else {
        this.disable_nav = true;
        return this.disable_nav;
      }
    },

    handleDrawerOnRoute(to, from) {
    
    if (to.path.includes("/widgets/")) {
      this.app_bar_active = false;
    }

    if (to.path.includes("/inbox")) {
      this.num_matches = 0;
    }

    // Drawer behaviour based on route. 
    // Becasue there are tabindex on the search page, 
    // It was opening the drawer when navigating within /Search
    if (to.path.includes("/search") && !this.right_drawer) {
      //console.log("Route changed from:", from.path, "to:", to.path);
      //console.log("Previous route: " + this.previousRoute);
      if (!from || from.path !== "/search") {
        //console.log("Entering /search from another page, opening drawer");
        this.drawer = true;
      } else {
        //console.log("Navigated within /search, keeping drawer closed");
        this.drawer = false;
      }
    } else {
      this.drawer = false;
    }
    // Update the previous route
    this.previousRoute = to.path;

    if (to.name === "home") {
      this.showFilters = false;
      this.drawer = false;
    } else {
      this.showFilters = true;
    }
  },

    toggleDrawer() {
      //console.log("toggleDrawer fired");
      if (!this.drawer) return;
      this.drawer = !this.drawer;
    }

  }
};
</script>

<style>

.toggle-btn {
  position: absolute;
  top: 16px;
  left: 8px;
  z-index: 1001;
  background-color: transparent;
  color: white;
}

/* hide mobile version by default */
.logo .mobile {
  display: none;
}

@media (max-width: 600px) {
  .logo .mobile {
    display: block;
  }
  .logo .desktop {
    display: none;
  }

  .tab-menu {
    max-width: 200px;
  }

  .drawer {
    transition: all 0.2s ease-in-out;
  }
}

.fullscreen-drawer {
  top: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  left: auto !important; /* anchor from right */
  height: 100vh !important;
  max-width: calc(100vw - 40px) !important;
  margin-right: 40px !important;
  margin-left: auto !important;
  border-radius: 0 !important;
  z-index: 9999 !important;
  transition: width 0.3s ease, margin 0.3s ease;
}

</style>
